'use strict';

module.exports = require('./timers').setInterval;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/set-interval.js
 ** module id = 683
 ** module chunks = 0
 **/